// extracted by mini-css-extract-plugin
export default {"main":"App_main__g-ZH2","title":"App_title__zQTwp"};